import { presetDark, presetLight } from "@/config/color-presets";
import { useColorPresetName } from "@/layouts/settings/use-theme-color";
import { updateThemeColor } from "@/utils/update-theme-color";
import { useTheme } from "next-themes";
import { useEffect } from "react";
import { CiDark, CiLight } from "react-icons/ci";
import { ActionIcon } from "rizzui";

export default function ThemeSwitcherIcon() {
    const { theme, setTheme } = useTheme();
    const { colorPresetName } = useColorPresetName();

    useEffect(() => {
        if (theme === "light" && colorPresetName === "black") {
            updateThemeColor(
                presetLight.lighter,
                presetLight.light,
                presetLight.default,
                presetLight.dark,
                presetLight.foreground,
            );
        }
        if (theme === "dark" && colorPresetName === "black") {
            updateThemeColor(
                presetDark.lighter,
                presetDark.light,
                presetDark.default,
                presetDark.dark,
                presetDark.foreground,
            );
        }
    }, [theme, colorPresetName]);

    return (
        <ActionIcon
            aria-label="Theme"
            variant="text"
            key={theme}
            onClick={() => setTheme(theme === "light" ? "dark" : "light")}
            className="relative h-[34px] w-[34px] shadow backdrop-blur-md dark:bg-gray-100 md:h-9 md:w-9"
        >
            {/* <span className="radio-active mb-3 inline-flex rounded-lg ring-offset-4 ring-offset-background dark:ring-offset-gray-100"> */}
            {theme === "light" ? (
                <CiLight className="inline-block w-full text-center h-[24px] animate-spin-slow" />
            ) : (
                <CiDark className="inline-block w-full text-center h-[24px] animate-pulse" />
            )}
            {/* </span> */}
            {/* <span className="inline-block w-full text-center">{theme}</span> */}
        </ActionIcon>
    );
}
